import type { RbacPolicy } from "components/authorization/RbacPolicies";
import axiosClient from "../axios-client";

const BASE_URL = "user-auth";

export const getUserAuth = async (): Promise<RbacPolicy[]> => {
  const response = await axiosClient.get<RbacPolicy[]>(BASE_URL);
  return response.data;
};
